export const SZ_FUNERAL_CLAIM_ROUTING_SET_VALUE = "sizotsaFuneralClaim/routing/setValue/";

export const NAVIGATE_PREVIOUS = SZ_FUNERAL_CLAIM_ROUTING_SET_VALUE + "navigatePrevious";
export const NAVIGATE_NEXT = SZ_FUNERAL_CLAIM_ROUTING_SET_VALUE + "navigateNext";
export const NAVIGATE_INDEX = SZ_FUNERAL_CLAIM_ROUTING_SET_VALUE + "navigateIndex";
export const SET_NAVIGATION_DONE = SZ_FUNERAL_CLAIM_ROUTING_SET_VALUE + "navigationDone";
export const navigatePrevious = () => ({ type: NAVIGATE_PREVIOUS });
export const navigateNext = () => ({ type: NAVIGATE_NEXT });
export const navigateIndex = (value) => ({ type: NAVIGATE_INDEX, value });
export const setNavigationDone = () => ({ type: SET_NAVIGATION_DONE });


export const SET_ACTIVE_PAGE_INDEX = SZ_FUNERAL_CLAIM_ROUTING_SET_VALUE + "activePageIndex";
export const setActivePageIndex = (value) => ({
  type: SET_ACTIVE_PAGE_INDEX,
  value,
});

// per page transitions
export const ROUTING_TRANSITION = "sizotsaFuneralClaim/routing/transition/";

export const NAVIGATE_TO_CLAIMENT_DETAILS =
  ROUTING_TRANSITION + "toClaimentDetails";

export const navigateToClaimentDetails = () => ({
  type: NAVIGATE_TO_CLAIMENT_DETAILS ,
});

export const NAVIGATE_TO_DECEASED_DETAILS =
  ROUTING_TRANSITION + "toDeceasedDetails";

export const navigateToDeceasedDetails = () => ({
  type: NAVIGATE_TO_DECEASED_DETAILS,
});


export const NAVIGATE_TO_UPLOAD_DOCUMENTS =
  ROUTING_TRANSITION + "toUploadDocuments";

export const navigateToUploadDocuments = () => ({
  type: NAVIGATE_TO_UPLOAD_DOCUMENTS,
});

export const NAVIGATE_TO_SUCCESS =
  ROUTING_TRANSITION + "toSuccess";

export const navigateToSuccessPage = () => ({
  type: NAVIGATE_TO_SUCCESS,
});

//Progressbar transition
export const PROGRESS_BAR_TRANSITION=ROUTING_TRANSITION+"progressBar"
export const updateProgressBarStatus=(value)=>({
type: PROGRESS_BAR_TRANSITION,
value
})